<div class="all-mentors-grid-part">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="rows()"></grid-content>
</div>